var _mask, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_1288_1625",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H32C43.0457 0 52 8.95431 52 20V32C52 43.0457 43.0457 52 32 52H20C8.9543 52 0 43.0457 0 32V20Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.9543 8.95431 0 20 0H32C43.0457 0 52 8.95431 52 20V32C52 43.0457 43.0457 52 32 52H20C8.9543 52 0 43.0457 0 32V20Z",
    fill: "url(#paint0_linear_1288_1625)",
    fillOpacity: 0.16
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.40202 9.40202 -1 21 -1H31C42.598 -1 52 8.40202 52 20C52 9.50659 43.0457 1 32 1H20C8.9543 1 0 9.50659 0 20ZM52 52H0H52ZM0 52V0V52ZM52 0V52V0Z",
    fill: "white",
    fillOpacity: 0.08,
    mask: "url(#path-1-inside-1_1288_1625)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1288_1625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5414 25.4608C30.8649 25.4608 34.3954 21.9274 34.3954 17.6069C34.3954 13.2863 30.8649 9.75 26.5414 9.75C22.2179 9.75 18.6875 13.2834 18.6875 17.6039C18.6875 21.9245 22.2209 25.4579 26.5414 25.4579V25.4608Z",
    fill: "#01FF85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0252 31.7373C39.818 31.2223 39.5458 30.7429 39.235 30.2961C37.6578 27.9642 35.2223 26.4194 32.476 26.0436C32.1328 26.0081 31.7569 26.0791 31.4817 26.2833C30.0406 27.3457 28.3271 27.8961 26.5427 27.8961C24.7582 27.8961 23.0448 27.3486 21.6037 26.2833C21.3284 26.0762 20.9526 25.9755 20.6093 26.0436C17.8661 26.4224 15.3951 27.9642 13.8503 30.2961C13.5426 30.7429 13.2674 31.2579 13.0602 31.7373C12.9566 31.9444 12.9921 32.1841 13.0957 32.3883C13.3709 32.8677 13.7142 33.3501 14.022 33.7614C14.5014 34.4124 15.0163 34.9954 15.5993 35.5458C16.0787 36.0253 16.6291 36.4721 17.1766 36.919C19.8873 38.9431 23.1454 40.0055 26.5072 40.0055C29.8689 40.0055 33.1271 38.9431 35.8378 36.919C36.3853 36.5076 36.9357 36.0282 37.4151 35.5458C37.9626 34.9984 38.513 34.4124 38.9924 33.7614C39.3357 33.3146 39.6434 32.8707 39.9186 32.3883C40.0903 32.1811 40.1258 31.9414 40.0222 31.7373H40.0252Z",
    fill: "#01FF85"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1288_1625",
    x1: -14.7727,
    y1: -44.1509,
    x2: 77.1448,
    y2: 3.85987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#01FF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCEBEB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1288_1625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0833,
    height: 30.2557,
    fill: "white",
    transform: "translate(13 9.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.1c097539a3cf448d6a170cb1559b98ec.svg";
export { ForwardRef as ReactComponent };